import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource)

const API_URL = process.env.API_URL

export default {
  query (params) {
    return Vue.http.get(`${API_URL}users`, {params: params})
  },
  get (id) {
    return Vue.http.get(`${API_URL}users/${id}`)
  },
  create (data) {
    return Vue.http.post(`${API_URL}users`, data)
  },
  delete (id) {
    return Vue.http.delete(`${API_URL}users/${id}`)
  },
  update (id, data) {
    return Vue.http.patch(`${API_URL}users/${id}`, data)
  },
  checkEmailExists (email) {
    return Vue.http.post(`${API_URL}users/email/`, {email: email})
  },
  checkUsernameExists (username) {
    return Vue.http.post(`${API_URL}users/username/`, {username: username})
  },
  getPermissions () {
    return [
      {label: 'Centro de Custos', resource: 'costCenter', value: []},
      {label: 'Clientes', resource: 'client', value: []},
      {label: 'Clientes Prospecção', resource: 'prospectingCustomer', value: []},
      {label: 'Configurações', resource: 'setup', value: []},
      {label: 'Despesas', resource: 'expense', value: []},
      {label: 'Extratos Financeiros', resource: 'balance', value: []},
      {label: 'Faturamentos', resource: 'revenue', value: []},
      {label: 'Fornecedores', resource: 'provider', value: []},
      {label: 'Gestão de Contas', resource: 'account', value: []},
      {label: 'Pagamentos de Despesas', resource: 'payment', value: []},
      {label: 'Parceiros', resource: 'partner', value: []},
      {label: 'Rendimentos', resource: 'yield', value: []},
      {label: 'Usuários', resource: 'user', value: []}
    ]
  },
  getRoleName (role) {
    return this.getRoles().find(r => r.value === role).name
  }
}



// WEBPACK FOOTER //
// ./src/services/user.js